import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleOAuthCallback, parseOAuthCallback } from '../lib/auth/oauth';
import { LoadingScreen } from '../components/LoadingScreen';

export function OAuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent duplicate processing in React StrictMode (development)
    if (hasProcessed.current) {
      console.log('[OAuthCallback] Already processed, skipping duplicate call');
      return;
    }

    const processCallback = async () => {
      const params = parseOAuthCallback();

      if (!params) {
        setError('Invalid OAuth callback parameters');
        setTimeout(() => navigate('/signin'), 3000);
        return;
      }

      try {
        hasProcessed.current = true;
        console.log('[OAuthCallback] Processing OAuth callback...');
        await handleOAuthCallback(params.code, params.state);
        // handleOAuthCallback will redirect automatically
      } catch (error) {
        console.error('OAuth callback error:', error);
        setError('Failed to complete authentication. Redirecting to sign in...');
        setTimeout(() => navigate('/signin'), 3000);
      }
    };

    processCallback();
  }, [navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 dark:bg-avemio-dark-bg">
        <div className="max-w-md rounded-lg bg-white dark:bg-avemio-dark-surface p-8 shadow-lg border border-gray-200 dark:border-avemio-dark-border">
          <h1 className="mb-4 text-2xl font-bold text-red-600 dark:text-red-400">Authentication Error</h1>
          <p className="text-gray-700 dark:text-avemio-dark-text-primary">{error}</p>
        </div>
      </div>
    );
  }

  return <LoadingScreen message="Completing authentication..." />;
}

